import InputLabel from '../../form/InputLabel';
import ValuePicker from './ValuePicker';

interface Props extends React.ComponentProps<typeof ValuePicker> {
  name: string;
  label: string;
  tooltip?: string;
}

/** A ValuePicker laid out like the form's other card rows. */
export default function PickerField({
  name,
  label,
  tooltip,
  ...picker
}: Props) {
  return (
    <div className="input">
      <InputLabel name={name} label={label} tooltip={tooltip} />
      <ValuePicker {...picker} />
    </div>
  );
}
